// extracted by mini-css-extract-plugin
export default {"card":"r1-z","carouselContainer":"s1-z","carouselContent":"t1-z"};